import { Box, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import { PExtTwarAllianceSelectPage } from "../pages/p.ext.twar.alliance.select";
import { useExtTwar } from "./ext.twar";
import { usePlayer } from "./player"
import { GREY, INFO_COLOR, MAIN_COLOR, MAIN_COLOR_ACTIVE, SECONDARY_COLOR, WHITE } from "../style/theme";
import { UMargin, UMarginTop, URow, USection } from "../common/ui.page";
import { useOrder } from "./order";
import { useCrusade } from "./crusade";
import { CMatch, CPlayer } from "./cr.ui.crusade";
import { CSection } from "./cr.ui.page";
import { useUnit } from "./unit";
import { CPayButton, RP_COLOR } from "./cr.ui.requisition";
import { CUnitBox, CUnitBoxName, DataBar } from "./cr.ui.unit";
import { UDialog, UDialogCloseOnCompleteButton } from "../common/ui.dialog";
import { UButton, UListItemButton } from "../common/ui.buttons";
import { gradient } from "../common/ui.gradient";
import { useEffect, useState } from "react";
import { useReport } from "./report";
import { UnitList } from "./cr.ui.report";
import { Add, Remove } from "@mui/icons-material";
import { UIcon } from "../common/ui.icon";
import '../style/glow.css'
import { CRUSADE_RELICS_TWAR } from "./unit.relics.twar";
import { BATTLE_TRAITS_TWAR } from "./unit.traits.twar";
import { VanillaPlayerTitle, vanillaAdminRewards } from "./cr.ext.vanilla";

function playerCheck(player) {
    return Boolean(player.alliance);
}
function playerCheckModule(player) {
    if (!player.alliance) {
        return <PExtTwarAllianceSelectPage />
    }

    return <></>
}
function playerCrusadeTop(ext) {
    const alliance = ext.alliance;

    return <>
        <ListItem>
            <ListItemIcon>
                <UIcon size={32} name={alliance.icon} />
            </ListItemIcon>
            <ListItemText
                primaryTypographyProps={{ sx: { fontSize: 16 } }}
                primary={alliance.name} secondary={alliance.description} />
        </ListItem>

    </>
}
export function TwarListPlayers() {
    const order = useOrder()
    const crusade = useCrusade()

    const players = crusade.players
        .filter(p => Boolean(p.codex))
        .sort((p1, p2) => p2.wins - p1.wins || p2.cp - p1.cp);
    const alliances = crusade.alliances.sort((a1, a2) => a2.points - a1.points);

    return <CSection>
        <Stack>
            <Typography sx={{ color: GREY[800], fontWeight: 500, }}>Giocatori</Typography>

            <List>
                {alliances.map(a => <Stack key={a.id}>
                    <URow>
                        <ListItemText sx={{ paddingRight: 40 }} primary={a.name} secondary={a.description} />
                        <Box sx={{ margin: 2 }}>
                            <Typography className="glow" sx={{
                                color: "#F4C92F",
                                fontSize: 20,
                                fontWeight: 600,

                            }}>
                                {a.points}
                            </Typography>
                        </Box>
                    </URow>
                    {players.filter(p => a.players.includes(p.id)).map(p => <CPlayer key={p.id} player={p} />)}
                </Stack>)}

            </List>

        </Stack>
    </CSection>
}

export function TwarUnitSection() {
    const unit = useUnit();

    if (!unit.allowedVeteranType) {
        return <></>
    }

    return <CSection>
        {unit.veteran && <TwarUnitVeteran />}
        {!unit.veteran && <Stack spacing={2}>
            <Typography >Tyranic War Veteran</Typography>
            <Typography sx={{ fontSize: 12, color: GREY[800] }}>Partecipa alla caccia rendendo questa unità un Veterano delle Tyranic War!</Typography>
            <CPayButton onComplete={unit.reload} unitId={unit.id} type={'twar.veteran.' + unit.allowedVeteranType} />
        </Stack>}
    </CSection>
}
const TWAR_VETERAN = {
    "behemoth": "Striding Behemoth",
    "hunter": "Monster Hunter",
}
export const TWAR_COLOR = '#12AACC';
export const TWAR_COLOR_2 = '#004488';

export function TwarUnitVeteran() {
    const unit = useUnit();
    const veteran = unit.veteran;
    const hasSelection = veteran.nextHonours.length > 0;

    return <Stack>
        <Typography sx={{ lineHeight: 1, fontSize: 12, color: GREY[800] }}>Tyranic War Veteran</Typography>
        <Typography sx={{ fontSize: 16 }}>{TWAR_VETERAN[veteran.type]}</Typography>
        {!veteran.maxLevel && <LinearProgress variant="determinate" color={'info'} value={Math.min(veteran.tally, 10) * 10} />}

        <List>
            <Typography sx={{ lineHeight: 1, color: TWAR_COLOR }}>Onori ottenuti</Typography>
            {veteran.honours.map(h => <ListItem key={h.id}>
                <ListItemText primary={h.name} secondary={h.description} />
            </ListItem>)}
        </List>
        {hasSelection && <Box>
            <TwarUnitHonourSelection honours={veteran.nextHonours} />
        </Box>}
    </Stack>
}

export function TwarUnitHonourSelection(props) {
    const unit = useUnit();
    const { honours } = props;
    const style = gradient([TWAR_COLOR, TWAR_COLOR_2, '#DDAA33'])
    const [selected, setSelect] = useState()

    return <UDialog button={<UButton sx={{ ...style }} fullWidth variant="contained">Aggiungi Onore</UButton>}>
        <DialogTitle>Tyranic War - Aggiungi onore</DialogTitle>
        <DialogContent>
            <Typography>
                Scegli il percorso da far intraprendere a questo Veterano
            </Typography>
            <List>
                {honours.map(h => <UListItemButton selected={selected === h.vhId} onClick={() => setSelect(h.vhId)} key={h.id}>
                    <ListItemText primary={h.name} secondary={h.description} />
                </UListItemButton>)}
            </List>
        </DialogContent>
        <DialogActions>
            <UDialogCloseOnCompleteButton
                call={'twar/unit/' + unit.id + '/honour/' + selected + '/add'}
                onComplete={unit.reload}
                disabled={!selected} variant="contained" fullWidth >Aggiungi</UDialogCloseOnCompleteButton>
        </DialogActions>
    </UDialog>
}

export function TwarUnitStats() {
    const unit = useUnit();
    const veteran = unit.veteran;

    if (!veteran) {
        return <></>
    }

    return <>
        {!veteran.maxLevel && <DataBar name="Tyranic War Tally" value={veteran.tally} color={TWAR_COLOR} />}
    </>
}



function TwarReportAfterKills() {
    const report = useReport()
    const match = report.match;

    useEffect(() => {
        if (!report.custom.twarKills) {
            report.setCustom({ twarKills: [], twarKillsTitanic: [] })
        }
    }, [])

    if (!report.custom.twarKills && !report.custom.twarKillsTitanic) {
        return <></>
    }
    const validUnits = report.units.filter(u => Boolean(u.veteran)).filter(u => report.kills.includes(u.id));
    if (validUnits.length == 0) {
        return <></>
    }


    return <CSection>

        <UMargin>
            <Stack>
                <Typography sx={{ fontWeight: 600 }}>Uccisioni Striding Behemoth</Typography>
                <Typography sx={{ color: GREY[800] }}>Tra le uccisioni effettuate, indica quali sono Striding Behemoth (in rosso titanici)</Typography>
                <List>
                    <UnitList filter={u => Boolean(u.veteran)} Component={TwarUnitKillsCounter} />
                </List>
            </Stack>
        </UMargin>
    </CSection>
}

function TwarUnitKillsCounter(props) {
    const { unit } = props;
    const report = useReport()
    const [kills, setKills] = useState(0)
    const [killst, setKillst] = useState(0)
    const tkills = report.custom.twarKills;
    const tkillst = report.custom.twarKillsTitanic;
    const max = report.kills.filter(k => k === unit.id).length

    useEffect(() => {
        const id = unit.id;
        const upd = tkills.filter(k => k !== id)
        for (let i = 0; i < kills; i++) {
            upd.push(id)
        }
        const updt = tkillst.filter(k => k !== id)
        for (let i = 0; i < killst; i++) {
            updt.push(id)
        }
        report.setCustom({ twarKills: upd, twarKillsTitanic: updt })
    }, [kills, killst])


    return <CUnitBox
        color1={SECONDARY_COLOR}
        color2={'transparent'}
        unit={unit}
        Component={ListItem}>
        <Stack sx={{ flex: 1 }}>
            <CUnitBoxName unit={unit} />
        </Stack>
        <Stack>
            <Stack direction="row" alignItems="center">
                <IconButton onClick={() => { if (kills > 0) { setKills(kills - 1) } }}>
                    <Remove />
                </IconButton>
                <Typography sx={{ fontSize: 16, fontWeight: 600, color: kills > 0 ? TWAR_COLOR : GREY[800], width: 20, textAlign: 'center' }}>
                    {kills}
                </Typography>
                <IconButton disabled={kills + killst >= max} onClick={() => { setKills(kills + 1) }}>
                    <Add />
                </IconButton>
            </Stack>
            <Stack direction="row" alignItems="center">
                <IconButton sx={{ color: 'orange' }} onClick={() => { if (killst > 0) { setKillst(killst - 1) } }}>
                    <Remove />
                </IconButton>
                <Typography sx={{ fontSize: 16, fontWeight: 600, color: killst > 0 ? 'orange' : GREY[800], width: 20, textAlign: 'center' }}>
                    {killst}
                </Typography>
                <IconButton sx={{ color: 'orange' }} disabled={killst + kills >= max} onClick={() => { setKillst(killst + 1) }}>
                    <Add />
                </IconButton>
            </Stack>
        </Stack>
    </CUnitBox >

}
export function TwarListPlayedMatches(props) {
    const { matches } = props;
    var lastPhase = 0;
    const ret = [];

    matches.forEach(m => {
        if (m.phase !== lastPhase) {
            ret.push(<Typography sx={{
                padding: 2,
                fontSize: 12,
                fontWeight: 600,
                background: 'linear-gradient(90deg, #AA3344 0%, ' + GREY[100] + ' 100% )',
            }} key={'p' + m.phase}>Fase {m.phase}</Typography>)
            lastPhase = m.phase
        }
        ret.push(<CMatch key={m.id} match={m} />)
    });

    return <>
        {ret.reverse()}
    </>
}

export function TwarUnitUpgrades(props) {
    const { unit } = props;
    const honours = unit.veteran ? unit.veteran.honours : []

    return <>
        {
            honours.length > 0 && <Stack sx={{ marginTop: 2 }}>
                <Typography sx={{
                    fontSize: 12, color: TWAR_COLOR
                }}>Tyranic War</Typography>
                {honours.map(t => <ListItemText
                    key={t.id}
                    primary={t.name}
                    primaryTypographyProps={{ sx: { fontSize: 10, marginLeft: 2, } }}
                    secondary={t.description}
                    secondaryTypographyProps={{ sx: { fontSize: 10, marginLeft: 2, } }}
                />)}

            </Stack>
        }
    </>

}

export const TWAR_MODULE = {
    playerCheck,
    playerCheckModule,
    playerCrusadeTop,
    playerList: () => <TwarListPlayers />,
    unitSections: () => <TwarUnitSection />,
    unitStats: () => <TwarUnitStats />,
    unitUpgrades: (unit) => <TwarUnitUpgrades unit={unit} />,
    playerTitle: () => <VanillaPlayerTitle />,

    matchesListPlayed: (matches) => <TwarListPlayedMatches matches={matches} />,

    reportAfterKills: () => <TwarReportAfterKills />,

    adminRewards: vanillaAdminRewards,
    matchCall: (crusadeId, matchId) => 'twar/match/' + crusadeId + '-' + matchId + '/report/submit',
    docs: ['doc-crusade-core', 'doc-tyranic-war'],

    relics: CRUSADE_RELICS_TWAR,
    traits: BATTLE_TRAITS_TWAR,
}